import './MoreButtonSkeleton.scss';

const MoreButtonSkeleton = () => {

    return (
        <div className="more__button__skeleton"></div>
    );
};

export default MoreButtonSkeleton;